import { MutationStatus } from '@tanstack/react-query';

import { RequestState } from '../constants/RequestState';

export const convertStatusToRequestState = (
  status: MutationStatus,
): RequestState => {
  switch (status) {
    case 'loading':
      return RequestState.Loading;
    case 'success':
      return RequestState.Success;
    case 'error':
      return RequestState.Error;
    case 'idle':
    default:
      return RequestState.Idle;
  }
};
